export enum SpaName {
    AFFILIATE = "AFFILIATE",
    MEMBER_ONBOARDING = "MEMBER_ONBOARDING",
    MEMBER_TRANSFER = "MEMBER_TRANSFER",
    UPDATE_PROFILE = "UPDATE_PROFILE",
    PCS_ENROLMENT = "PCS_ENROLMENT",
    PCS_RE_ENROLMENT = "PCS_RE_ENROLMENT"
}